"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "medole": {
    "e085e4f2": [{
      "hkey": "b70a8aab",
      "slug": "medole",
      "name": "Medole",
      "primary": true,
      "skipSearch": false
    }],
    "annunciata": [{
      "hkey": "b70a8aab",
      "slug": "medole",
      "name": "Medole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e2becbb0": [{
      "hkey": "b70a8aab",
      "slug": "medole",
      "name": "Medole",
      "primary": true,
      "skipSearch": false
    }],
    "ca-morino": [{
      "hkey": "b70a8aab",
      "slug": "medole",
      "name": "Medole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "134a6026": [{
      "hkey": "b70a8aab",
      "slug": "medole",
      "name": "Medole",
      "primary": true,
      "skipSearch": false
    }],
    "gelmina": [{
      "hkey": "b70a8aab",
      "slug": "medole",
      "name": "Medole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bd55a016": [{
      "hkey": "b70a8aab",
      "slug": "medole",
      "name": "Medole",
      "primary": true,
      "skipSearch": false
    }],
    "san-damaso": [{
      "hkey": "b70a8aab",
      "slug": "medole",
      "name": "Medole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "59b3ef4e": [{
      "hkey": "b70a8aab",
      "slug": "medole",
      "name": "Medole",
      "primary": true,
      "skipSearch": false
    }],
    "sassi": [{
      "hkey": "b70a8aab",
      "slug": "medole",
      "name": "Medole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cfba892c": [{
      "hkey": "b70a8aab",
      "slug": "medole",
      "name": "Medole",
      "primary": true,
      "skipSearch": false
    }],
    "soldana": [{
      "hkey": "b70a8aab",
      "slug": "medole",
      "name": "Medole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f65c2eca": [{
      "hkey": "b70a8aab",
      "slug": "medole",
      "name": "Medole",
      "primary": true,
      "skipSearch": false
    }],
    "vanni": [{
      "hkey": "b70a8aab",
      "slug": "medole",
      "name": "Medole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;